import React from "react";
import './index.css'
import { compareTeams } from "../../utils/orderTeams";
import { useSelector } from "react-redux";
import { secureUrl } from "../../../../../../utils/sortArray/secureUrl";
import useIsMobileAndPortrait from "../../../../../../hooks/useIsMobile";
import SponsorsFooter from "../../../matchGames/components/matchGame/components/SponsorsFoooter";

const TableForPosition = ({infoGroup, name})=>{
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
   const orderTeamsbyGroup= infoGroup?.sort(compareTeams)
    const hasSponsor = selectedTournament?.tienePatrocinadores && selectedTournament?.patrocinadores?.length > 0 
    const sponsors = selectedTournament?.patrocinadores
    const { isMobile, isPortrait } = useIsMobileAndPortrait();

    return(<div className="talachaapp-body-tableposotion">
        <div className="talachaapp-header-container">
        <p className="talachaapp-title-group">{name}</p>
        <div className="sponsor-table">

        </div>
        <div className="talachaapp-tournamen-selected">
            <img src={secureUrl(selectedTournament?.imgPicture)} />
            <p>{selectedTournament?.name}</p>
        </div>


        </div>
        <div className="tatalachaapp-header-title">
            <div className="tatalachaapp-header-title-nameTeam">
Equipo
            </div>
            <div style={{fontWeight:'bolder'}}>
                PTS
            </div>
           <div>
            <p>PJ</p>
            </div>
                            {
                    !isMobile && (
                        <>
                                    <div>
            <p>G</p>

            </div>
            <div>
            <p>E</p>

            </div>
            <div>
            <p>P</p>

            </div>
                        </>

                    )
                }

            <div>
            <p>GF</p>

            </div>
            <div>
            <p>GC</p>

            </div>
            <div>
            <p>DG</p>

            </div>

  
        </div>
        {
                orderTeamsbyGroup?.map((team, index) => (
                    <div className="talachaapp-body-teams">

                    <div className="tatalachaapp-body-teams-nameTeam">
                        <p className="tatalachaapp-body-teams-nameTeam-position">{index + 1}</p>
                        <img className="img-table-postion-by-group" src={secureUrl(team?.img)} />
                        
                        {team?.name}
                        </div>
                        <div style={{fontWeight:'bolder'}} className="talachaapp-teams-total-points">
                            {team?.TotalPuntos}
                        </div>
                       <div>
                        <p>{team?.jornadas}</p>
                        </div>
                        {
                            !isMobile && (
                                <>
                                                        <div>
                        <p>{team?.result?.ganados || 0}</p>
                        </div>
                        <div>
                        <p>{team?.result?.empatados || 0}</p>
            
                        </div>
                        <div>
                        <p>{team?.result?.perdidos || 0}</p>
                        </div>
                                </>
                            )
                        }

                        <div>
                        <p>{team?.TotalGolesA}</p>
            
                        </div>
                        <div>
                        <p>{team?.TotalGolesC}</p>
            
                        </div>
                        <div>
                        <p>{team?.TotalGolesA -team?.TotalGolesC }</p>
            
                        </div>
            
                    </div>
                ))
            }



        <SponsorsFooter />
    </div>)
}

export default TableForPosition